import { Order, PlanCar, PlanDest } from '@/types/plan';
import { BasicInfo, Car, Dest, DestDetail, ShippingDetail, TimeLine } from '@/types/result';
import { atom } from 'jotai';
import { atomWithReset } from 'jotai/utils';

export const DEFAULT_ZOOM = 9;
export const MARKER_VIEW_ZOOM = 9;
// fitBounds 대상 좌표가 한 점에 가깝게 몰려있을 때 지나치게 확대되는 것을 막는 상한.
export const MAX_RESET_ZOOM = 14;

export const backdropAtom = atomWithReset<boolean>(true);
export const backdropTextAtom = atomWithReset<string>('');

export const shippingListCollapseAtom = atomWithReset<boolean>(true);

export const basicInfoAtom = atomWithReset<BasicInfo>(undefined);

export const shippingListAtom = atomWithReset<ShippingDetail[]>([]);

export const selectedCarListAtom = atomWithReset<number[]>([]);

export const mapCenterCoorAtom = atomWithReset<naver.maps.Coord>(undefined);

export const mapZoomLevelAtom = atomWithReset<number>(DEFAULT_ZOOM);

// 배차건 전환 시 지도를 강제로 재조정해야 할 때만 쓰는 atom. mapCenterCoorAtom(목적지 클릭 시
// 줌은 유지한 채 이동)과는 분리되어 있다. 차량 출발지 + 배송지 좌표들을 담아두면, RouteMap이
// map.fitBounds()로 이 좌표들이 전부 보이는 center/zoom을 한 번에 계산해서 적용한다.
export const mapResetViewAtom = atomWithReset<naver.maps.Coord[] | undefined>(undefined);

export const destDetailAtom = atomWithReset<DestDetail>(undefined);

export const shippingCardOverAtom = atomWithReset<number>(undefined);

export const polyLineOverAtom = atomWithReset<number>(undefined);

export const timeLineAtom = atomWithReset<boolean>(false);

export const timeLineOrgArrAtom = atomWithReset<TimeLine[]>([]);
export const timeLineChgArrAtom = atomWithReset<TimeLine[]>([]);
export const resultDestListAtom = atomWithReset<any[]>([]);

export const changeCarListAtom = atomWithReset<number[]>([]);

export const reRouteListAtom = atomWithReset<any[]>([]);

export const allDestListModalAtom = atomWithReset<boolean>(false);
export const allCarListModalAtom = atomWithReset<boolean>(false);
export const allOrderListModalAtom = atomWithReset<boolean>(false);
export const allNotAssignListModalAtom = atomWithReset<boolean>(false);

//PLAN ATOM
//PLAN MODAL
export const selectOrderModalAtom = atomWithReset<boolean>(false);
export const destInfoModalAtom = atomWithReset<boolean>(false);
export const selectCarModalAtom = atomWithReset<boolean>(false);
export const carInfoModalAtom = atomWithReset<boolean>(false);

export const planRegistConfirmAtom = atomWithReset<boolean>(false);

export const selectedCenterAtom = atomWithReset<number>(undefined);

export const selectedOrderListAtom = atomWithReset<Order[] | PlanDest[]>([]);
export const selectedPlanCarListAtom = atomWithReset<PlanCar[]>([]);

export const planDestListAtom = atomWithReset<PlanDest[]>([]);
export const planCarListAtom = atomWithReset<PlanCar[]>([]);

export const targetShippingSeqAtom = atomWithReset<number>(undefined);
export const shippingMainModalAtom = atomWithReset<boolean>(false);

export const shippingCompleteAtom = atomWithReset<boolean>(false);

export const SHIPPING_TYPE: any = {
  0: '최소차량',
  1: '모든차량',
  2: '최소차량',
  3: '모든차량',
};
